<script setup>
import JobDetailContent from 'module/jobDetailContent/JobDetailContent.vue';
import MasterLayout from 'layout/master/MasterLayout.vue';
import { onMounted, ref } from 'vue';

const props = defineProps({
    jobDetailContent: {
        type: Object,
        required: true,
    },
    layout: {
        type: Object,
        required: true,
    },
});

function sendAdWordsTracking() {
    window.dataLayer.push({
        googleAdsData: {
            job_pagetype: 'offerdetail',
            job_id: props.jobDetailContent.jobContent.id,
        },
    });
}

onMounted(sendAdWordsTracking);

const jobDetailContentRef = ref(null);
onMounted(() => jobDetailContentRef.value?.sendShowEvents());
</script>

<template>
    <MasterLayout :layout>
        <div class="c-jobDetail">
            <JobDetailContent
                ref="jobDetailContentRef"
                :active="jobDetailContent.active"
                :alarm-disruptor="jobDetailContent.alarmDisruptor"
                :apply-action="jobDetailContent.applyAction"
                :is-preview="jobDetailContent.isPreview"
                :is-seamless="jobDetailContent.isSeamless"
                :job-content="jobDetailContent.jobContent"
                :job-detail="jobDetailContent.jobDetail"
                :job-header="jobDetailContent.jobHeader"
                :job-suggestions="jobDetailContent.jobSuggestions"
                :keyfact-box="jobDetailContent.keyfactBox"
                :new-version="layout.newVersion"
                :share-modal="jobDetailContent.shareModal"
                :tabs="jobDetailContent.tabs"
                :show-keyfact-box="jobDetailContent.showKeyfactBox"
            />
        </div>
    </MasterLayout>
</template>

<style lang="scss">
@use "styles";
</style>
